const baseImageUrl = 'https://www.geeksroot.com/images';

export const caseStudiesData = [
  {
    slug: 'fitmama',
    title: 'Fitmama',
    menuLabel: 'Fitmama',
    category: 'Fitness App',
    platform: 'iOS + Android',
    path: '/case-studies/fitmama',
    legacyPath: '/fitmama.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/case01.jpg`,
    hoverImage: `${baseImageUrl}/case01hover.jpg`,
    summary: 'A premium fitness companion shaped around daily routines, guided workouts, and simple member progress for busy women.',
    intro: 'Fitmama needed a mobile experience that felt motivating without becoming noisy. The product direction focused on quick starts, clear workout paths, and a visual language that makes health goals feel reachable every day.',
    metrics: [
      ['2', 'mobile platforms'],
      ['40+', 'guided routines'],
      ['3x', 'faster onboarding'],
    ],
    highlights: ['Workout journey mapping', 'Membership experience', 'Progress-first dashboard'],
    challenge: 'The brand had strong coaching value, but the mobile journey needed to organize workout plans, memberships, and motivation into one calm flow.',
    solution: 'We shaped a habit-driven app structure with clear training categories, lightweight onboarding, premium visual rhythm, and conversion-focused membership prompts.',
    outcome: 'The experience became easier to scan, easier to start, and more confidence-building for users returning to their fitness routine.',
    features: ['Goal-based onboarding', 'Workout library', 'Membership plans', 'Progress tracking', 'Coach-led content', 'Push reminders'],
    process: [
      ['01', 'Routine Mapping', 'Mapped user goals, workout contexts, and repeat-visit moments.'],
      ['02', 'Mobile UX', 'Built fast paths for training discovery, membership choices, and daily progress.'],
      ['03', 'Visual Polish', 'Added energetic motion, card states, and a modern fitness look.'],
      ['04', 'Launch Ready', 'Prepared responsive app screens and handoff details for scalable updates.'],
    ],
    stack: ['React Native', 'Firebase', 'Stripe', 'Figma', 'Node.js', 'Analytics'],
    gallery: ['Training plan dashboard', 'Class detail experience', 'Membership checkout'],
    testimonial: {
      name: 'Mari Carmen Fitness',
      role: 'Fitness Founder',
      text: 'The product feels focused, premium, and easy for members to use during real training days.',
    },
  },
  {
    slug: 'hats',
    title: 'Hats by LYNX',
    menuLabel: 'Hats',
    category: 'Learning Platform',
    platform: 'Mobile App',
    path: '/case-studies/hats',
    legacyPath: '/hats.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/case3.jpg`,
    hoverImage: `${baseImageUrl}/case3hover.jpg`,
    summary: 'A focused hotel English learning product built for staff training, lesson clarity, and progress visibility.',
    intro: 'Hats by LYNX required a learning interface that staff could use during demanding schedules. The experience favors short sessions, practical vocabulary, and visible improvement without overwhelming learners.',
    metrics: [
      ['5', 'lesson tracks'],
      ['24/7', 'mobile access'],
      ['80%', 'less friction'],
    ],
    highlights: ['Lesson architecture', 'Staff progress UX', 'Practical learning flows'],
    challenge: 'Hospitality training often becomes difficult to keep consistent because staff need short, purposeful lessons that work around service shifts.',
    solution: 'We organized lessons into compact modules, added clear completion states, and designed a learning path that keeps users oriented from first lesson to review.',
    outcome: 'The platform now supports practical language training with a cleaner structure and a more confident mobile learning rhythm.',
    features: ['Course modules', 'Vocabulary practice', 'Progress tracking', 'Lesson reminders', 'Manager visibility', 'Offline-friendly flows'],
    process: [
      ['01', 'Learning Audit', 'Defined the most useful hospitality scenarios and learner constraints.'],
      ['02', 'Content Model', 'Grouped lessons into practical categories with simple completion logic.'],
      ['03', 'Mobile Design', 'Created a polished learning interface with quick repeat access.'],
      ['04', 'Quality Pass', 'Reviewed interaction states, readability, and responsive behavior.'],
    ],
    stack: ['React Native', 'Laravel', 'MySQL', 'Figma', 'REST API', 'Analytics'],
    gallery: ['Lesson library', 'Vocabulary drills', 'Learner progress'],
    testimonial: {
      name: 'LYNX Training Team',
      role: 'Hospitality Education',
      text: 'The app makes training easier to follow and gives the program a much more professional feel.',
    },
  },
  {
    slug: 'tycoon',
    title: 'NFT Tycoons',
    menuLabel: 'Tycoon',
    category: 'NFT Marketplace',
    platform: 'Web3',
    path: '/case-studies/tycoon',
    legacyPath: '/tycoon.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/case4.jpg`,
    hoverImage: `${baseImageUrl}/case4hover.jpg`,
    summary: 'A collector-first NFT marketplace concept with sharp discovery, asset storytelling, and trusted transaction paths.',
    intro: 'NFT Tycoons needed to make Web3 browsing feel less complex and more desirable. The product system balances bold collection visuals with marketplace clarity, wallet readiness, and simple ownership cues.',
    metrics: [
      ['Web3', 'marketplace'],
      ['100+', 'asset layouts'],
      ['4', 'collector flows'],
    ],
    highlights: ['Marketplace UX', 'Wallet-ready journeys', 'Digital asset presentation'],
    challenge: 'Collectors needed confidence while browsing assets, but the interface also had to carry a premium, energetic trading feel.',
    solution: 'We designed marketplace cards, collection pages, bid states, and ownership details around trust, hierarchy, and visual impact.',
    outcome: 'The final direction gives collectors a sharper way to discover, compare, and act on digital assets.',
    features: ['Collection pages', 'Asset detail views', 'Wallet prompts', 'Creator profiles', 'Bid states', 'Marketplace filtering'],
    process: [
      ['01', 'Market Flow', 'Defined browsing, bidding, and ownership decision points.'],
      ['02', 'Design System', 'Created high-contrast UI patterns for collectors and creators.'],
      ['03', 'Web3 UX', 'Reduced transaction anxiety with clear wallet and asset states.'],
      ['04', 'Responsive Build', 'Optimized browsing grids for desktop, tablet, and mobile.'],
    ],
    stack: ['React', 'Node.js', 'Web3.js', 'MongoDB', 'MetaMask', 'AWS'],
    gallery: ['Collection storefront', 'Asset detail page', 'Marketplace filters'],
    testimonial: {
      name: 'NFT Tycoons Team',
      role: 'Digital Collectibles',
      text: 'The marketplace direction feels premium while making complex Web3 actions easier to understand.',
    },
  },
  {
    slug: 'universe-queen',
    title: 'Universe Queen',
    menuLabel: 'Universe Queen',
    category: 'NFT Storefront',
    platform: 'Web3',
    path: '/case-studies/universe-queen',
    legacyPath: '/universe_queen.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/case2.jpg`,
    hoverImage: `${baseImageUrl}/case2hover.jpg`,
    summary: 'A bold NFT storefront that turns artwork, collection browsing, and purchase intent into a premium visual journey.',
    intro: 'Universe Queen leaned on strong artwork and needed an interface that could preserve that energy while still guiding users toward browsing, collection details, and purchase decisions.',
    metrics: [
      ['1', 'premium storefront'],
      ['6', 'collection states'],
      ['High', 'visual impact'],
    ],
    highlights: ['Art-led interface', 'Collection storytelling', 'Conversion-focused storefront'],
    challenge: 'The brand needed a dramatic digital presence, but NFT storefront journeys still require practical clarity and trust.',
    solution: 'We paired large artwork moments with controlled content blocks, animated detail reveals, and clear collection CTAs.',
    outcome: 'The storefront feels expressive and polished while keeping collector actions simple and visible.',
    features: ['Hero collection showcase', 'Rarity sections', 'Wallet pathway', 'Artist story', 'Drop countdowns', 'Mobile storefront'],
    process: [
      ['01', 'Art Direction', 'Built the visual rhythm around the collection personality.'],
      ['02', 'UX Structure', 'Separated story, collection, and action areas for cleaner scanning.'],
      ['03', 'Motion Layer', 'Added subtle reveal and hover states to support the premium feel.'],
      ['04', 'Launch Polish', 'Checked responsive presentation and storefront hierarchy.'],
    ],
    stack: ['Next.js', 'Web3.js', 'Tailwind', 'Sanity', 'Vercel', 'Figma'],
    gallery: ['Hero artwork system', 'Collection detail', 'Drop landing section'],
    testimonial: {
      name: 'Universe Queen Studio',
      role: 'NFT Collection',
      text: 'The interface gives the collection the space and drama it needs while still feeling easy to use.',
    },
  },
  {
    slug: 'truck-and-fins',
    title: 'Truck And Fins',
    menuLabel: 'Truck And Fins',
    category: 'Skate Finder',
    platform: 'Progressive Web App',
    path: '/case-studies/truck-and-fins',
    legacyPath: '/truckandfins.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/case5.jpg`,
    hoverImage: `${baseImageUrl}/case5hover.jpg`,
    summary: 'A location-first PWA for discovering skateparks, indoor ramps, street spots, and nearby places worth exploring.',
    intro: 'Truck And Fins needed to feel quick, outdoorsy, and useful the moment a skater opened it. The core product challenge was discovery: show nearby spots fast, then make filtering and details effortless.',
    metrics: [
      ['PWA', 'fast access'],
      ['Geo', 'spot discovery'],
      ['4', 'place types'],
    ],
    highlights: ['Location UX', 'Map-led discovery', 'Community-friendly flows'],
    challenge: 'Skaters needed a fast way to find useful locations without digging through cluttered listings or slow pages.',
    solution: 'We built the experience around map-first discovery, sharp filter chips, nearby result cards, and detail pages that answer practical questions quickly.',
    outcome: 'The PWA direction makes spot discovery feel immediate, mobile-friendly, and much easier to repeat.',
    features: ['Map search', 'Nearby filters', 'Spot detail cards', 'Indoor/outdoor tags', 'Favorites', 'PWA install prompt'],
    process: [
      ['01', 'Discovery Logic', 'Defined how users search, filter, and compare nearby spots.'],
      ['02', 'Map Interface', 'Prioritized readable pins, result cards, and quick context.'],
      ['03', 'PWA Polish', 'Tuned the experience for fast mobile access and repeat use.'],
      ['04', 'Content QA', 'Reviewed empty states, place metadata, and route handoff.'],
    ],
    stack: ['React', 'Google Maps', 'PWA', 'Node.js', 'MongoDB', 'AWS'],
    gallery: ['Nearby map view', 'Spot detail panel', 'Saved places flow'],
    testimonial: {
      name: 'Truck And Fins',
      role: 'Skate Community Product',
      text: 'The product now feels fast and genuinely helpful for people trying to find the right place to ride.',
    },
  },
  {
    slug: 'play-on',
    title: 'Play On',
    menuLabel: 'Play On',
    category: 'Sports Booking',
    platform: 'Progressive Web App',
    path: '/case-studies/play-on',
    legacyPath: '/playon.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/playon-snooker.jpg`,
    hoverImage: `${baseImageUrl}/playon-snooker-hover.jpg`,
    summary: 'A snooker-focused booking PWA designed for fast venue discovery, slot selection, and smoother game planning.',
    intro: 'Play On brings sports booking into a cleaner digital flow. The product needed to help players find available tables, understand venue details, and move from intent to booking quickly.',
    metrics: [
      ['3', 'booking steps'],
      ['PWA', 'mobile-first'],
      ['Live', 'slot clarity'],
    ],
    highlights: ['Booking UX', 'Venue discovery', 'Responsive PWA flow'],
    challenge: 'Players needed a straightforward way to discover venues and book a table without calling, waiting, or guessing availability.',
    solution: 'We designed a short booking path with visible venue data, time slots, availability states, and conversion-focused action areas.',
    outcome: 'The experience reduces booking friction and makes the product feel dependable for repeat play sessions.',
    features: ['Venue listing', 'Slot selection', 'Booking summary', 'Player profiles', 'Event cards', 'Payment-ready layout'],
    process: [
      ['01', 'Booking Model', 'Mapped discovery, availability, and confirmation steps.'],
      ['02', 'Mobile Screens', 'Created a compact flow that works well during quick decisions.'],
      ['03', 'Interaction States', 'Designed sold-out, selected, pending, and confirmed states.'],
      ['04', 'Performance Pass', 'Kept the PWA fast and readable across devices.'],
    ],
    stack: ['React', 'PWA', 'Laravel', 'MySQL', 'Stripe', 'Figma'],
    gallery: ['Venue discovery', 'Slot selection', 'Booking confirmation'],
    testimonial: {
      name: 'Play On Team',
      role: 'Sports Booking',
      text: 'The booking journey feels quicker, clearer, and much more polished for players on mobile.',
    },
  },
  {
    slug: 'professional-scopists',
    title: 'Professional Scopists',
    menuLabel: 'Professional Scopists',
    category: 'Service Platform',
    platform: 'Web App',
    path: '/case-studies/professional-scopists',
    legacyPath: '/professional_scopist.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/case7.jpg`,
    hoverImage: `${baseImageUrl}/case7hover.jpg`,
    summary: 'A refined service platform for court reporters who need trusted scopists, proofreading support, and clearer lead capture.',
    intro: 'Professional Scopists required a website that could explain a specialist service with credibility. The user journey had to make expertise obvious and move potential clients toward contact without pressure.',
    metrics: [
      ['B2B', 'service flow'],
      ['Clear', 'lead capture'],
      ['Trust', 'first design'],
    ],
    highlights: ['Service positioning', 'Lead journey', 'Credibility-focused UI'],
    challenge: 'The service is specialized, so the interface had to educate quickly while building confidence with a professional audience.',
    solution: 'We created a calm structure with service clarity, proof-led content sections, intake prompts, and a polished visual system.',
    outcome: 'The platform now communicates expertise faster and gives users a clearer path to inquire about support.',
    features: ['Service pages', 'Lead forms', 'Trust sections', 'FAQ strategy', 'Responsive layout', 'Content hierarchy'],
    process: [
      ['01', 'Audience Review', 'Clarified what court reporters need to know before contacting.'],
      ['02', 'Content System', 'Reorganized services, benefits, and intake details.'],
      ['03', 'Interface Polish', 'Built a professional UI with restrained motion and clear hierarchy.'],
      ['04', 'Conversion QA', 'Reviewed forms, CTAs, and mobile reading flow.'],
    ],
    stack: ['React', 'Node.js', 'MongoDB', 'Figma', 'Email API', 'Analytics'],
    gallery: ['Service overview', 'Intake flow', 'Trust-led homepage'],
    testimonial: {
      name: 'Professional Scopists',
      role: 'Court Reporting Support',
      text: 'The site explains the service clearly and gives the brand a stronger professional presence.',
    },
  },
  {
    slug: 'washup',
    title: 'Washup',
    menuLabel: 'Washup',
    category: 'Laundry Platform',
    platform: 'Web App',
    path: '/case-studies/washup',
    legacyPath: '/washup.php',
    accent: '#785CFF',
    image: `${baseImageUrl}/case8.jpg`,
    hoverImage: `${baseImageUrl}/case8hover.jpg`,
    summary: 'A dependable laundry-service platform designed around clear orders, customer trust, and everyday convenience.',
    intro: 'Washup needed a clean service experience for customers managing pickups, laundry preferences, and order status. The design direction centers on clarity, trust, and repeat service behavior.',
    metrics: [
      ['3', 'order phases'],
      ['Web', 'service platform'],
      ['Fast', 'repeat orders'],
    ],
    highlights: ['Order management UX', 'Customer clarity', 'Service operations'],
    challenge: 'Laundry ordering has many small details, so users needed confidence around timing, preferences, pricing, and status.',
    solution: 'We shaped a practical flow with service cards, order summaries, clear status states, and a repeat-friendly account experience.',
    outcome: 'The product feels easier to use for customers and more organized for service operations.',
    features: ['Pickup flow', 'Order summary', 'Service pricing', 'Status tracking', 'Customer account', 'Repeat order actions'],
    process: [
      ['01', 'Service Mapping', 'Defined pickup, cleaning, delivery, and support touchpoints.'],
      ['02', 'Order UX', 'Created a clear path from service choice to confirmation.'],
      ['03', 'Operations View', 'Designed status and customer details for smoother handling.'],
      ['04', 'Responsive QA', 'Checked the experience across daily mobile and desktop use.'],
    ],
    stack: ['React', 'Laravel', 'MySQL', 'Stripe', 'AWS', 'Figma'],
    gallery: ['Pickup scheduling', 'Order dashboard', 'Service pricing cards'],
    testimonial: {
      name: 'Washup Team',
      role: 'Laundry Service',
      text: 'The platform makes the service feel simpler, more organized, and easier for customers to trust.',
    },
  },
];

export const caseStudyAliases = caseStudiesData.flatMap((study) => [study.path, study.legacyPath]);

export function getCaseStudyBySlug(slug) {
  return caseStudiesData.find((study) => study.slug === slug);
}
